<template>
  <div class="card text-center p-0">
    <div v-if="news.image != ''"><img class="img-fluid mt-1 mb-0" rel="noreferrer" :src="news.image" /></div>
    <div class="card-body i42FullLine text-body">
      <small v-html="news.displaylink"></small>
      <br>
      <small class="text-info">{{timeago}}</small>
      <p class="card-text text-dark i42FullLine d-none d-sm-block">
        <small v-html="news.title"></small>
      </p>
      <a :href="news.link" rel="noreferrer" class="stretched-link"/>
    </div>
  </div>
</template>

<script>
import moment from "moment";
moment.locale('de');

export default {
  name: "ContentStaticProviderItem",

  props: {
    news: null
  },

  computed: {
    timeago: function() {
      return moment(this.news.pubDate).fromNow();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.i42FullLine {
  line-height: 100%;
}

.i42OversizeLine {
  line-height: 120%;
}
</style>
